import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  mostrarCampoTitulo(event) {
    event.preventDefault()
    document.getElementById('campo-titulo').classList.remove('hidden')
    event.target.remove()
  }
}
